export var Regions;
(function (Regions) {
    Regions["UsEast"] = "us-east-1";
    Regions["Europe"] = "eu-central-1";
    Regions["UnitedKingdom"] = "eu-west-2";
    Regions["AsiaPacific"] = "ap-southeast-2";
    Regions["Canada"] = "ca-central-1";
    Regions["Japan"] = "ap-northeast-1";
})(Regions || (Regions = {}));
export const regions = {
    [Regions.UsEast]: { name: 'US East (N. Virginia)', code: 'us' },
    [Regions.AsiaPacific]: { name: 'Asia Pacific (Sydney)', code: 'au' },
    [Regions.Canada]: { name: 'Canada (Central)', code: 'ca' },
    [Regions.Europe]: { name: 'Europe (Frankfurt)', code: 'eu' },
    [Regions.UnitedKingdom]: { name: 'Europe (London)', code: 'uk' },
    [Regions.Japan]: { name: 'Asia Pacific (Tokyo)', code: 'jp' },
};
export const getRegionCode = (region) => {
    if (Object.keys(regions).find(currentRegion => region === currentRegion)) {
        return regions[region].code;
    }
    // Support future additions of new regions
    // DEV-25066 should send a log for unmapped regions
    return null;
};
//# sourceMappingURL=regions.js.map